import {observable, makeObservable, runInAction, action} from "mobx";
import {message, RadioChangeEvent, UploadFile} from "antd";
import api from "../../../api";
import axios from "axios";
import dayjs from "dayjs";
import LoginStore from "../login_store";
import CommonStore from "../common_store";

class addCompanyStore {
    //表单字段
    @observable accountInformationFormData: any = {};
    @observable enterpriseRealNameFormData: any = {};
    @observable admissionMaterialsFormData: any = {};
    @observable newAdmissionMaterialsFormData: any = {};
    @observable operatorFormData: any = {};
    @observable currentStep: number = 0;

    //实名认证
    @observable businessLicenseImage: string = ""; //营业执照图片
    @observable legalPersonIdFront: string = ""; //法人身份证正面
    @observable legalPersonIdBack: string = ""; //法人身份证反面
    @observable bankPermitImage: string = ""; //开户许可证图片

    //准入材料上传
    @observable businessCommitmentLetter: UploadFile[] = []; //工作号业务开通承诺函
    @observable networkSecurityCommitment: UploadFile[] = []; //网络及信息安全承诺书
    @observable customerResponsibilityAuthorization: UploadFile[] = []; //客户责任授权书
    @observable businessUsageCommitment: UploadFile[] = []; //规范使用业务承诺书
    @observable scene: UploadFile[] = []; //场景使用说明
    @observable accountSceneList: any = []; //场景列表
    @observable businessApplicationInstructions: UploadFile[] = []; //工作号业务应用说明
    @observable speechTemplate: UploadFile[] = []; //话术模板
    @observable socialSecurityProof: UploadFile[] = []; //社保证明
    @observable qualificationProof: UploadFile[] = []; //资质证明
    @observable contractChain: UploadFile[] = []; //合同链
    @observable oTherScenes: any = []; //其他场景列表

    @observable getManagerList: any = []; //客户经理字典
    //经办人身份认证
    @observable agentIdFront: string = ""; //经办人身份证正面
    @observable agentIdBack: string = ""; //经办人身份证反面
    @observable codeTime: number = 60; //验证码倒计时
    @observable getCode: boolean = false; //是否获取验证码
    // @observable verifiedPhone: boolean = false; //是否验证成功号码
    @observable urlLink: string = ""; //小程序二维码地址
    @observable wxCheckURLBtn: boolean = false; //小程序二维码地址
    //   @observable QRCode: boolean = false; //是否展现二维码
    @observable authenticationCode: string = "";
    @observable intervalId: any = null;
    @observable wxCheckResult: string = ""; //身份认证结果
    @observable customerAddResult: boolean = false;

    @observable buttonLoading: boolean = false;

    loginStore: LoginStore;
    commonStore: CommonStore;

    constructor(
        baseStore: LoginStore,
        baseStore1: CommonStore,
    ) {
        this.loginStore = baseStore;
        this.commonStore = baseStore1;
        makeObservable(this);
    }

    switchGetCode(flag: boolean) {
        runInAction(() => {
            this.getCode = flag;
        });
    }

    toGetCode() {
        if (
            this.operatorFormData.agentPhoneNumber &&
            /^(\+?86|0)?1\d{10}$/.test(this.operatorFormData.agentPhoneNumber)
        ) {
            api.chooseCompanyApi
                .getPhoneCode({
                    agentPhoneNumber: this.operatorFormData.agentPhoneNumber,
                })
                .then((res) => {
                    runInAction(() => {
                        this.codeTime = 6;
                    });
                    this.switchGetCode(true);
                    this.countdown();
                })
                .catch((e) => {
                });
        } else {
            message.error("请先输入正确的手机号码");
        }
    }
    //找所有场景
    @action
    getSceneList() {
        api.chooseCompanyApi
            .sceneList()
            .then((res: any) => {
                runInAction(() => {
                    const arr=[]
                    arr.push(res.data)
                    this.accountSceneList =[...arr] ;
                });
            })
            .catch((e: any) => {});
    }

    countdown() {
        if (this.codeTime > 0) {
            runInAction(() => {
                this.codeTime -= 1;
            });
            setTimeout(() => this.countdown(), 1000);
        }
    }

    toCheckPhone() {
        if (
            this.operatorFormData.agentPhoneNumber &&
            /^(\+?86|0)?1\d{10}$/.test(this.operatorFormData.agentPhoneNumber) &&
            this.operatorFormData.phoneVerificationCode
        ) {
            api.chooseCompanyApi
                .checkPhoneCode({
                    agentPhoneNumber: this.operatorFormData.agentPhoneNumber,
                    phoneVerificationCode: this.operatorFormData.phoneVerificationCode,
                })
                .then((res: any) => {
                    runInAction(() => {
                        if (res.code == 200) {
                            runInAction(() => {
                                this.operatorFormData.phoneVerificationSuccessCode = res.data;
                            });
                        }
                    });
                })
                .catch((e) => {
                });
        } else {
            message.error("请先输入正确的手机号码和验证码");
        }
    }

    // 提交时处理准入材料格式
    setNewAdmissionMaterialsFormData() {
        const extractObjectName = (fileList: any) =>
            fileList.map((file: any) => {
                return {
                    fileName: file.name,
                    objectName: file.objectName,
                };
            });

        // 定义一个对象，包含所有需要提取的属性和对应的数组
        const propertiesToExtract: any = {
            businessCommitmentLetter: this.businessCommitmentLetter,
            networkSecurityCommitment: this.networkSecurityCommitment,
            customerResponsibilityAuthorization:
            this.customerResponsibilityAuthorization,
            businessUsageCommitment: this.businessUsageCommitment,
            scene: this.scene,
            businessApplicationInstructions: this.businessApplicationInstructions,
            speechTemplate: this.speechTemplate,
            socialSecurityProof: this.socialSecurityProof,
            qualificationProof: this.qualificationProof,
            contractChain: this.contractChain,
        };

        this.newAdmissionMaterialsFormData={...this.admissionMaterialsFormData}
        Object.keys(propertiesToExtract).forEach((key) => {
            this.newAdmissionMaterialsFormData[key] = extractObjectName(
                propertiesToExtract[key]
            );
        });
        console.log(JSON.parse(JSON.stringify(this.newAdmissionMaterialsFormData)))
        // this.newAdmissionMaterialsFormData.sceneIds=this.admissionMaterialsFormData.sceneIds
    }

    @observable addCompanyModal: IModal = {
        add: false,
        update: false,
        updateModalType: (type: "add") => {
        },
        get isOpen(): boolean {
            return this.add || this.update;
        },
        open: (type: "add" | "update", data: any) => {
            if (type === "add") {
                runInAction(() => {
                    this.formInitialization();
                    this.addCompanyModal.add = true;
                });
            } else if (type === "update") {
                if (this.commonStore.homePageDataList.authStatus === 'FAILED' && data === '企业认证') {
                    //认证失败重新认证
                    api.chooseCompanyApi.getDetail(3).then((res: any) => {
                        runInAction(() => {
                            this.setFormData(res,'all')
                            this.getFileUrl(this.enterpriseRealNameFormData)
                            this.operatorFormData = {};
                            this.addCompanyModal.update = true;
                            this.addCompanyModal.add = false;
                        });
                    }).catch((e) => {
                    }).finally(() => {
                    })
                } else if (data === '企业认证变更') {
                    api.chooseCompanyApi.getDetail(1).then((res: any) => {
                        runInAction(() => {
                            this.setFormData(res,'enterprise')
                            this.getFileUrl(this.enterpriseRealNameFormData)
                            this.operatorFormData = {};
                            this.addCompanyModal.update = true;
                            this.addCompanyModal.add = false;
                        });
                    }).catch((e) => {
                    }).finally(() => {
                    })
                } else if (data === '账户信息变更') {
                    api.chooseCompanyApi.getDetail(2).then((res: any) => {
                        runInAction(() => {
                            this.setFormData(res,'account')
                            this.getFileUrl(this.enterpriseRealNameFormData)
                            this.operatorFormData = {};
                            this.addCompanyModal.update = true;
                            this.addCompanyModal.add = false;
                        });
                    }).catch((e) => {
                    }).finally(() => {
                    })
                }
            }
        },
        close: () => {
            runInAction(() => {
                this.addCompanyModal.add = false;
                this.addCompanyModal.update = false;
                this.formInitialization();
                this.setStep(0);
            });
        },
    };

    //获取申请相关文件临时下载地址, 有效期为10分钟
    @action
    async getFileUrl(data: any) {
        if (data.legalPersonIdFront) {
            await api.chooseCompanyApi
                .getFileUrl(data.legalPersonIdFront.objectName)
                .then((res: any) => {
                    runInAction(() => {
                        this.legalPersonIdFront = res.data;
                    });
                })
                .catch((err: any) => {
                });
        }
        if (data.legalPersonIdBack) {
            await api.chooseCompanyApi
                .getFileUrl(data.legalPersonIdBack.objectName)
                .then((res: any) => {
                    runInAction(() => {
                        this.legalPersonIdBack = res.data;
                    });
                })
                .catch((err: any) => {
                });
        }
        if (data.bankPermitImage) {
            await api.chooseCompanyApi
                .getFileUrl(data.bankPermitImage.objectName)
                .then((res: any) => {
                    runInAction(() => {
                        this.bankPermitImage = res.data;
                    });
                })
                .catch((err: any) => {
                });
        }
        if (data.businessLicenseImage) {
            await api.chooseCompanyApi
                .getFileUrl(data.businessLicenseImage.objectName)
                .then((res: any) => {
                    runInAction(() => {
                        this.businessLicenseImage = res.data;
                    });
                })
                .catch((err: any) => {
                });
        }
    }

    formInitialization() {
        runInAction(() => {
            this.wxCheckURLBtn=false
            this.urlLink='';
            this.businessLicenseImage = "";
            this.legalPersonIdFront = "";
            this.legalPersonIdBack = "";
            this.bankPermitImage = "";
            this.accountInformationFormData = {};
            this.enterpriseRealNameFormData = {};
            this.admissionMaterialsFormData = {};
            this.operatorFormData = {};
            this.businessCommitmentLetter = []
            this.networkSecurityCommitment = []
            this.customerResponsibilityAuthorization = []
            this.businessUsageCommitment = []
            this.scene = []
            this.businessApplicationInstructions = []
            this.speechTemplate = []
            this.socialSecurityProof = []
            this.qualificationProof = []
            this.contractChain = []
        });
    }

    setFormData(res: any,flag:string) {
        if (flag==='all'||flag==='account'){
            //账户信息
            this.accountInformationFormData.businessAccountName = res.data?.businessAccountName
            this.accountInformationFormData.customerManagerCode = res.data?.customerManagerCode
            this.accountInformationFormData.signingCompany = res.data?.signingCompany
            this.accountInformationFormData.contactName = res.data?.contactName
            this.accountInformationFormData.contactPhoneNumber = res.data?.contactPhoneNumber
            this.accountInformationFormData.contactEmail = res.data?.contactEmail
        }

        if (flag==='all'||flag==='enterprise'){
            //客户实名
            this.enterpriseRealNameFormData.customerCreditCode = res.data?.customerCreditCode
            this.enterpriseRealNameFormData.customerName = res.data?.customerName
            this.enterpriseRealNameFormData.registeredCapital = res.data?.registeredCapital
            this.enterpriseRealNameFormData.establishmentDate = dayjs(res.data?.establishmentDate)
            if (res.data?.businessExpireDate=='长期'){
                this.enterpriseRealNameFormData.businessExpireDateFlag='1'
            }else {
                this.enterpriseRealNameFormData.businessExpireDateFlag='2'
                if (res.data?.businessExpireDate)this.enterpriseRealNameFormData.businessExpire=dayjs(res.data?.businessExpireDate)
            }
            this.enterpriseRealNameFormData.legalPersonName = res.data?.legalPersonName
            this.enterpriseRealNameFormData.legalPersonIdNumber = res.data?.legalPersonIdNumber
            this.enterpriseRealNameFormData.bankAccountNumber = res.data?.bankAccountNumber
            this.enterpriseRealNameFormData.bankAccountName = res.data?.bankAccountName
            this.enterpriseRealNameFormData.legalPersonIdFront = res.data?.legalPersonIdFront
            this.enterpriseRealNameFormData.legalPersonIdBack = res.data?.legalPersonIdBack
            this.enterpriseRealNameFormData.businessLicenseImage = res.data?.businessLicenseImage
            this.enterpriseRealNameFormData.bankPermitImage = res.data?.bankPermitImage
            //准入材料
            this.admissionMaterialsFormData.businessCommitmentLetter = res.data?.businessCommitmentLetter.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.networkSecurityCommitment = res.data?.networkSecurityCommitment.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.customerResponsibilityAuthorization = res.data?.customerResponsibilityAuthorization.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.businessUsageCommitment = res.data?.businessUsageCommitment.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.scene = res.data?.scene.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.sceneIds = res.data?.sceneIds
            this.admissionMaterialsFormData.otherContents = res.data?.otherContents
            this.admissionMaterialsFormData.businessApplicationInstructions = res.data?.businessApplicationInstructions.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.speechTemplate = res.data?.speechTemplate.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.socialSecurityProof = res.data?.socialSecurityProof.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.qualificationProof = res.data?.qualificationProof.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.admissionMaterialsFormData.contractChain = res.data?.contractChain.map((item: any, index: number) => ({
                objectName: item.objectName,
                uid: item.objectName,
                name: item.fileName
            }))
            this.businessCommitmentLetter = this.admissionMaterialsFormData.businessCommitmentLetter
            this.networkSecurityCommitment = this.admissionMaterialsFormData.networkSecurityCommitment
            this.customerResponsibilityAuthorization = this.admissionMaterialsFormData.customerResponsibilityAuthorization
            this.businessUsageCommitment = this.admissionMaterialsFormData.businessUsageCommitment
            this.scene = this.admissionMaterialsFormData.scene
            this.businessApplicationInstructions = this.admissionMaterialsFormData.businessApplicationInstructions
            this.speechTemplate = this.admissionMaterialsFormData.speechTemplate
            this.socialSecurityProof = this.admissionMaterialsFormData.socialSecurityProof
            this.qualificationProof = this.admissionMaterialsFormData.qualificationProof
            this.contractChain = this.admissionMaterialsFormData.contractChain
        }
        this.setAccountInformationFormData({...this.accountInformationFormData})
        this.setEnterpriseRealNameFormData({...this.enterpriseRealNameFormData})
        this.setAdmissionMaterialsFormData({...this.admissionMaterialsFormData})
    }

    setAccountInformationFormData(obj: any) {
        runInAction(() => {
            this.accountInformationFormData = obj;
        });
    }

    setEnterpriseRealNameFormData(obj: any) {
        runInAction(() => {
            this.enterpriseRealNameFormData = obj;
        });
    }

    setAdmissionMaterialsFormData(obj: any) {
        runInAction(() => {
            this.admissionMaterialsFormData = obj;
        });
    }

    setOperatorFormData(obj: any) {
        runInAction(() => {
            this.operatorFormData = obj;
        });
    }

    setStep(current: number) {
        runInAction(() => {
            this.currentStep = current;
        });
    }

    // 上传客户图片
    @action
    uploadImageFile(name: string, file: any) {
        api.chooseCompanyApi
            .fileUpload({fileName: file.name})
            .then(async (res: any) => {
                await this.uploadFile(file, res.data.urlPath);
                if (name === "businessLicenseImage") {
                    runInAction(() => {
                        this.enterpriseRealNameFormData.businessLicenseImage = {
                            fileName: res.data.fileName,
                            objectName: res.data.objectName,
                        };
                    });
                } else if (name === "bankPermitImage") {
                    runInAction(() => {
                        this.enterpriseRealNameFormData.bankPermitImage = {
                            fileName: res.data.fileName,
                            objectName: res.data.objectName,
                        };
                    });
                } else if (name === "legalPersonIdFront") {
                    runInAction(() => {
                        this.enterpriseRealNameFormData.legalPersonIdFront = {
                            fileName: res.data.fileName,
                            objectName: res.data.objectName,
                        };
                    });
                } else if (name === "legalPersonIdBack") {
                    runInAction(() => {
                        this.enterpriseRealNameFormData.legalPersonIdBack = {
                            fileName: res.data.fileName,
                            objectName: res.data.objectName,
                        };
                    });
                } else if (name === "agentIdFront") {
                    runInAction(() => {
                        this.operatorFormData.agentIdFront = {
                            fileName: res.data.fileName,
                            objectName: res.data.objectName,
                        };
                    });
                } else if (name === "agentIdBack") {
                    runInAction(() => {
                        this.operatorFormData.agentIdBack = {
                            fileName: res.data.fileName,
                            objectName: res.data.objectName,
                        };
                    });
                }
            })
            .catch((err: any) => {
            });
    }

    //获取临时上传地址
    @action
    async temporaryUpload(file: any, name: string) {
        await api.chooseCompanyApi
            .fileUpload({fileName: file.name})
            .then(async (res: any) => {
                file.objectName = res.data.objectName;
                await this.uploadFile(file, res.data.urlPath);
                this.setpdfList(
                    [...(this[name as keyof typeof this] as any), file],
                    name
                );
            })
            .catch((err: any) => {
            });
    }

    //上传到临时地址
    uploadFile(file: any, url: any) {
        axios
            .put(url, file, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: false,
            })
            .then((response) => {
            })
            .catch((err) => {
            });
    }

    @action
    setpdfList(obj: any, name: string) {
        runInAction(() => {
            this[name as keyof typeof this] = obj;
        });
    }

    async toCheckCustomer(registeredCapital: number, establishmentDate: string) {
        api.chooseCompanyApi
            .checkCustomer({registeredCapital, establishmentDate})
            .then((res: any) => {
                if (res.data) {
                    this.setStep(this.currentStep + 1);
                } else {
                    message.error("企业注册资金需大于100万，且成立时间至少为一年！");
                }
            })
            .catch((err: any) => {
            });
    }
    //营业有效期赋值
    setBusinessExpireDate(flag:string){
        if (flag==='1'){
            this.enterpriseRealNameFormData.businessExpireDate='长期'
        }else if (flag==='2'){
            this.enterpriseRealNameFormData.businessExpireDate=dayjs(this.enterpriseRealNameFormData.businessExpire).format('YYYY-MM-DD')
        }
        this.setEnterpriseRealNameFormData(this.enterpriseRealNameFormData)
    }
    toCheckAM(code: string) {
        api.chooseCompanyApi
            .checkManagerCode({userNo:code})
            .then((res: any) => {
                if (res.data) {
                    this.setStep(this.currentStep + 1);
                } else {
                    message.error("请输入正确的客户经理编码");
                }
            })
            .catch((err: any) => {
            });
    }
    toGetOtherScenes() {
        api.chooseCompanyApi
            .getOtherScenes('scene_other_input_names')
            .then((res: any) => {
                this.oTherScenes=res.data
            })
            .catch((err: any) => {
            });
    }

    @action
    onChangeRadio(e: RadioChangeEvent) {
        runInAction(() => {
            this.operatorFormData.phoneVerificationSuccessCode = "";
        });
        if (e.target.value == 0) {
            runInAction(() => {
                this.operatorFormData.agentName =
                    this.enterpriseRealNameFormData.legalPersonName;
                this.operatorFormData.agentIdNumber =
                    this.enterpriseRealNameFormData.legalPersonIdNumber;
                this.operatorFormData.agentIdFront =
                    this.enterpriseRealNameFormData.legalPersonIdFront;
                this.operatorFormData.agentIdBack =
                    this.enterpriseRealNameFormData.legalPersonIdBack;
            });
        }
    }

    //获取二维码地址
    @action
    async wxCheckURL(type: string) {
        if (type === "经办人身份认证") {
            this.wxCheckURLBtn=true
            if (this.operatorFormData.phoneVerificationSuccessCode) {
                if (this.currentStep===1 && this.operatorFormData.agentType==0){
                    try {
                        let res= await api.chooseCompanyApi.getDetail(1)
                        runInAction(() => {
                            this.operatorFormData.agentName =res.data.legalPersonName
                            this.operatorFormData.agentIdNumber =res.data.legalPersonIdNumber
                            this.operatorFormData.agentIdFront =res.data.legalPersonIdFront
                            this.operatorFormData.agentIdBack=res.data.legalPersonIdBack
                        });
                    }catch (e) {
                        console.log(e)
                    }
                }
                if ((this.operatorFormData.agentName && this.operatorFormData.agentIdNumber && this.operatorFormData.agentIdFront && this.operatorFormData.agentIdBack && JSON.stringify(this.operatorFormData.agentType))) {
                    await api.chooseCompanyApi
                        .wxCheckURL(this.operatorFormData)
                        .then(async (res: any) => {
                            runInAction(() => {
                                this.urlLink = res.data.urlLink;
                                this.wxCheckURLBtn=false
                                this.authenticationCode = res.data.authenticationCode;
                            });
                            if (this.urlLink) {
                                this.myIntervalFunction();
                            }
                        })
                        .catch((err: any) => {
                            this.wxCheckURLBtn=false
                            clearInterval(this.intervalId);
                        });
                } else {
                    this.wxCheckURLBtn=false
                    message.error("请检查经办人身份，经办人姓名，经办人身份证号码，经办人身份证正面，经办人身份证反面是否填写完成");
                }
            } else {
                this.wxCheckURLBtn=false
                message.error("请先完成手机号码验证");
            }
        } else {
            clearInterval(this.intervalId);
            runInAction(() => {
                this.wxCheckURLBtn=false
                this.urlLink = "";
                this.authenticationCode = "";
                this.wxCheckResult = "";
            });
        }
    }

    myIntervalFunction() {
        this.intervalId = setInterval(() => {
            this.wxCheckURLResult();
        }, 3000);
    }

    //查询微信活体检测是否成功
    async wxCheckURLResult() {
        runInAction(() => {
            this.operatorFormData.authenticationCode = this.authenticationCode;
        });
        api.chooseCompanyApi
            .wxCheckURLResult(this.operatorFormData)
            .then((res: any) => {
                if (res.data !== "1") {
                    runInAction(() => {
                        this.wxCheckResult = res.data;
                    });
                    clearInterval(this.intervalId);
                }
            })
            .catch((err: any) => {
                clearInterval(this.intervalId);
            });
    }

    //门户平台新增企业客户和企业客户账户接口
    async customerAdd() {
        clearInterval(this.intervalId);
        runInAction(() => {
            this.enterpriseRealNameFormData.establishmentDate = this.enterpriseRealNameFormData.establishmentDate ? dayjs(this.enterpriseRealNameFormData.establishmentDate) : "";
            this.buttonLoading = true;
        });

        const data = Object.assign(
            {},
            this.accountInformationFormData,
            this.enterpriseRealNameFormData,
            this.newAdmissionMaterialsFormData,
            this.operatorFormData
        );

        await api.chooseCompanyApi
            .customerAdd(data)
            .then((res: any) => {
                message.success("提交成功");
                runInAction(() => {
                    this.urlLink = "";
                    this.authenticationCode = "";
                    this.wxCheckResult = "";
                    this.accountInformationFormData = {};
                    this.enterpriseRealNameFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.operatorFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.getCode = false;
                    this.operatorFormData.phoneVerificationSuccessCode = "";
                    this.buttonLoading = false;
                    this.customerAddResult = true
                });
                this.addCompanyModal.close();
                this.loginStore.getOrgList();
                this.setStep(0);
            })
            .catch((err: any) => {
                runInAction(() => {
                    this.customerAddResult = false
                    this.buttonLoading = false;
                });
            });
    }

    //企业认证变更
    async realNameUpdate() {
        clearInterval(this.intervalId);
        runInAction(() => {
            this.enterpriseRealNameFormData.establishmentDate = this.enterpriseRealNameFormData.establishmentDate ? dayjs(this.enterpriseRealNameFormData.establishmentDate) : "";
            this.buttonLoading = true;
        });

        const data = Object.assign(
            {},
            this.enterpriseRealNameFormData,
            this.newAdmissionMaterialsFormData,
            this.operatorFormData
        );
        data.type=2

        await api.chooseCompanyApi
            .customerAuthUpdate(data)
            .then((res: any) => {
                message.success("提交成功");
                runInAction(() => {
                    this.urlLink = "";
                    this.authenticationCode = "";
                    this.wxCheckResult = "";
                    this.enterpriseRealNameFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.operatorFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.getCode = false;
                    this.operatorFormData.phoneVerificationSuccessCode = "";
                    this.buttonLoading = false;
                    this.customerAddResult = true
                });
                this.addCompanyModal.close();
                this.commonStore.getHomePageData()
                this.loginStore.getOrgList();
                this.setStep(0);
            })
            .catch((err: any) => {
                runInAction(() => {
                    this.customerAddResult = false
                    this.buttonLoading = false;
                });
            });
    }
    //企业认证
    async realNameAdd() {
        clearInterval(this.intervalId);
        runInAction(() => {
            this.enterpriseRealNameFormData.establishmentDate = this.enterpriseRealNameFormData.establishmentDate ? dayjs(this.enterpriseRealNameFormData.establishmentDate) : "";
            this.buttonLoading = true;
        });

        const data = Object.assign(
            {},
            this.accountInformationFormData,
            this.enterpriseRealNameFormData,
            this.newAdmissionMaterialsFormData,
            this.operatorFormData
        );
        data.type=1

        await api.chooseCompanyApi
            .customerAuthUpdate(data)
            .then((res: any) => {
                message.success("提交成功");
                runInAction(() => {
                    this.urlLink = "";
                    this.authenticationCode = "";
                    this.wxCheckResult = "";
                    this.accountInformationFormData = {};
                    this.enterpriseRealNameFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.operatorFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.getCode = false;
                    this.operatorFormData.phoneVerificationSuccessCode = "";
                    this.buttonLoading = false;
                    this.customerAddResult = true
                });
                this.addCompanyModal.close();
                this.commonStore.getHomePageData()
                this.loginStore.getOrgList();
                this.setStep(0);
            })
            .catch((err: any) => {
                runInAction(() => {
                    this.customerAddResult = false
                    this.buttonLoading = false;
                });
            });
    }
    //新用户认证失败再认证
    async newCustomersrealNameAdd() {
        clearInterval(this.intervalId);
        runInAction(() => {
            this.enterpriseRealNameFormData.establishmentDate = this.enterpriseRealNameFormData.establishmentDate ? dayjs(this.enterpriseRealNameFormData.establishmentDate) : "";
            this.buttonLoading = true;
        });

        const data = Object.assign(
            {},
            this.accountInformationFormData,
            this.enterpriseRealNameFormData,
            this.newAdmissionMaterialsFormData,
            this.operatorFormData
        );
        data.type=5

        await api.chooseCompanyApi
            .customerAuthUpdate(data)
            .then((res: any) => {
                message.success("提交成功");
                runInAction(() => {
                    this.urlLink = "";
                    this.authenticationCode = "";
                    this.wxCheckResult = "";
                    this.accountInformationFormData = {};
                    this.enterpriseRealNameFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.operatorFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.getCode = false;
                    this.operatorFormData.phoneVerificationSuccessCode = "";
                    this.buttonLoading = false;
                    this.customerAddResult = true
                });
                this.addCompanyModal.close();
                this.commonStore.getHomePageData()
                this.loginStore.getOrgList();
                this.setStep(0);
            })
            .catch((err: any) => {
                runInAction(() => {
                    this.customerAddResult = false
                    this.buttonLoading = false;
                });
            });
    }
    //账户信息变更
    async accountUpdate() {
        clearInterval(this.intervalId);
        runInAction(() => {
            this.enterpriseRealNameFormData.establishmentDate = this.enterpriseRealNameFormData.establishmentDate ? dayjs(this.enterpriseRealNameFormData.establishmentDate) : "";
            this.buttonLoading = true;
        });

        const data = Object.assign(
            {},
            this.accountInformationFormData,
            this.operatorFormData
        );
        data.type=3

        await api.chooseCompanyApi
            .customerAuthUpdate(data)
            .then((res: any) => {
                message.success("提交成功");
                runInAction(() => {
                    this.urlLink = "";
                    this.authenticationCode = "";
                    this.wxCheckResult = "";
                    this.accountInformationFormData = {};
                    this.operatorFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.getCode = false;
                    this.operatorFormData.phoneVerificationSuccessCode = "";
                    this.buttonLoading = false;
                    this.customerAddResult = true
                });
                this.addCompanyModal.close();
                this.commonStore.getHomePageData()
                this.loginStore.getOrgList();
                this.setStep(0);
            })
            .catch((err: any) => {
                runInAction(() => {
                    this.customerAddResult = false
                    this.buttonLoading = false;
                });
            });
    }
    //新增账户
    async accountAdd() {
        clearInterval(this.intervalId);
        runInAction(() => {
            this.enterpriseRealNameFormData.establishmentDate = this.enterpriseRealNameFormData.establishmentDate ? dayjs(this.enterpriseRealNameFormData.establishmentDate) : "";
            this.buttonLoading = true;
        });

        const data = Object.assign(
            {},
            this.accountInformationFormData,
            this.operatorFormData
        );
        data.type=4

        await api.chooseCompanyApi
            .customerAuthUpdate(data)
            .then((res: any) => {
                message.success("提交成功");
                runInAction(() => {
                    this.urlLink = "";
                    this.authenticationCode = "";
                    this.wxCheckResult = "";
                    this.accountInformationFormData = {};
                    this.operatorFormData = {};
                    this.newAdmissionMaterialsFormData = {};
                    this.getCode = false;
                    this.operatorFormData.phoneVerificationSuccessCode = "";
                    this.buttonLoading = false;
                    this.customerAddResult = true
                });
                this.addCompanyModal.close();
                this.commonStore.getHomePageData()
                this.loginStore.getOrgList();
                this.setStep(0);
            })
            .catch((err: any) => {
                runInAction(() => {
                    this.customerAddResult = false
                    this.buttonLoading = false;
                });
            });
    }

    //获取企业准入客户经理字典
    @action
    async get_manager_code() {
        await api.chooseCompanyApi
            .get_manager_code({})
            .then((res: any) => {
                runInAction(() => {
                    this.getManagerList = res.data;
                });
            })
            .catch((e: any) => {
            });
    }

    //经办人身份认证返回清空数据
    @action
    callBackLast() {
        clearInterval(this.intervalId);
        runInAction(() => {
            this.operatorFormData = {};
            this.wxCheckResult = "";
            this.intervalId = null;
            this.authenticationCode = "";
            this.wxCheckURLBtn=false;
            this.urlLink = "";
        });
    }
}

export default addCompanyStore;
